export default __webpack_public_path__ + "static/media/payments-sample-check.f3673d0f.png";